// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
// For Firebase JS SDK v9-compat and later, measurementId is optional
const firebaseConfig = {
  // Replace with your actual Firebase config
  apiKey: "AIzaSyBpuEH9_-erRrEdUKQ46Fkec4IgW9RqhiQ",
  authDomain: "mylocalforce-295b8.firebaseapp.com",
  projectId: "mylocalforce-295b8",
  storageBucket: "mylocalforce-295b8.firebasestorage.app",
  messagingSenderId: "1081005319135",
  appId: "1:1081005319135:web:7f2e7a0a54d120ff019a6a",
  measurementId: "G-T0QRB4GM95",
  databaseURL: "https://mylocalforce-295b8-default-rtdb.firebaseio.com",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
// Using custom database name 'mylocalforce' instead of default '(default)'
export const db = getFirestore(app, 'mylocalforce');
// Initialize Firebase Storage
export const storage = getStorage(app);

// Initialize Realtime Database
export const rtdb = getDatabase(app);

// Cloud Functions
export const functions = getFunctions(app, 'us-central1');

export default app;
